// eslint-disable-next-line import/no-cycle
import store from '@/store/index';

export const getDebugOptions = () => store.state.debugOptions;
